import { render } from "./RuiSend.vue?vue&type=template&id=110eef53"
const script = {}
script.render = render

export default script